// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"71":"robots-grid","176":"projects","381":"robots"}[chunkId] + "." + {"71":"be5c7846","176":"9f11db13","381":"5c615572"}[chunkId] + ".js";
};